import * as THREE from 'three/webgpu';

/**
 * 旋转切除保留实体高亮网格。
 *
 * 文件职责：
 * 1. 表示一个可保留片段的高亮层；
 * 2. 禁用 raycast，避免遮挡真实实体选择；
 * 3. 由 RevolveCutKeepBodyPreviewManager 统一管理资源释放。
 */
export class RevolveCutKeepBodyPreviewMesh extends THREE.Mesh {
    /** 来源实体 ID。 */
    public readonly sourceSolidId: string;
    /** 片段稳定键。 */
    public readonly shapeKey: string;

    /**
     * @param input 输入参数。
     */
    public constructor(input: {
        sourceSolidId: string;
        shapeKey: string;
        geometry: THREE.BufferGeometry;
        material: THREE.Material;
    }) {
        super(input.geometry, input.material);
        this.sourceSolidId = input.sourceSolidId;
        this.shapeKey = input.shapeKey;
        this.name = `revolve-cut-keep-body:${input.sourceSolidId}:${input.shapeKey}`;
        this.renderOrder = 12;
    }

    /**
     * 禁用拾取。
     *
     * 设计说明：
     * 1. 高亮层只提供视觉反馈；
     * 2. 真实选择仍应命中正式结果体或草图对象；
     * 3. 覆写 raycast 可避免透明网格抢占交互。
     */
    public override raycast(): void {
        return;
    }
}
